'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var STRING_COLLATOR = window.Intl && _typeof(window.Intl) === 'object' && new Intl.Collator();

exports.default = function (option1, option2) {
  var option1Text = option1.text;
  var option2Text = option2.text;
  var comparisonResult = 0;
  if (STRING_COLLATOR) {
    comparisonResult = STRING_COLLATOR.compare(option1Text, option2Text);
  } else if (option1Text > option2Text) {
    comparisonResult = 1;
  } else if (option2Text > option1Text) {
    comparisonResult = -1;
  }

  return comparisonResult;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.2379/js/internal/utils/sortOptions.js
// module id = 564
// module chunks = 3 4 5